import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO.jsx";

export default function NotFound() {
  return (
    <>
      <SEO
        title="Record scratch – Page not found | MusicBase"
        description="We couldn’t find the page you were looking for. Go back to the homepage or explore other releases."
        robots="noindex, nofollow"
      />
      <main
        style={{
          minHeight: "calc(100vh - var(--appbar-h))",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "40px 20px",
          backgroundColor: "#f3f4f6",
        }}
      >
        <div
          style={{
            maxWidth: 520,
            width: "100%",
            backgroundColor: "#fef2f2",
            borderRadius: 24,
            border: "1px solid #fecaca",
            padding: "32px 24px 28px",
            boxShadow: "0 18px 45px rgba(0,0,0,0.08)",
            color: "#b91c1c",
          }}
        >
          {/* Top row: icon + close space (like the screenshot) */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              marginBottom: 20,
            }}
          >
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: "999px",
                border: "2px solid #b91c1c",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 700,
                fontSize: 18,
              }}
            >
              !
            </div>
            {/* placeholder for future “X” close if you reuse as a modal */}
            <span style={{ opacity: 0 }}>×</span>
          </div>

          <h1
            style={{
              fontSize: 28,
              lineHeight: 1.2,
              marginBottom: 16,
              fontWeight: 700,
            }}
          >
            Record scratch.
          </h1>

          <p
            style={{
              fontSize: 16,
              lineHeight: 1.6,
              color: "#7f1d1d",
              marginBottom: 24,
            }}
          >
            We couldn’t find the page you were looking for. It might have moved
            or never existed. You can go back to the homepage or keep exploring
            MusicBase.
          </p>

          <div
            style={{
              display: "flex",
              gap: 12,
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
          >
            <Link
              to="/"
              style={{
                padding: "12px 24px",
                borderRadius: 999,
                backgroundColor: "#b91c1c",
                color: "#fff",
                textDecoration: "none",
                fontWeight: 600,
                textAlign: "center",
                flexShrink: 0,
              }}
            >
              Go back home
            </Link>

            <button
              type="button"
              onClick={() => window.history.back()}
              style={{
                padding: "12px 20px",
                borderRadius: 999,
                border: "1px solid #fecaca",
                backgroundColor: "#fff",
                color: "#b91c1c",
                fontWeight: 500,
                cursor: "pointer",
                textAlign: "center",
                flexShrink: 0,
              }}
            >
              Go to previous page
            </button>
          </div>
        </div>
      </main>
    </>
  );
}
